import React, { FC } from "react";
import { Field } from "react-final-form";
import Select from "react-select";
import { DropdownIndicator, ReactSelectDropdownOption } from "@pepdirect/ui";

import { FieldProps } from "constants/field";
import {
  simpleDropdownSelectStyles,
  SimpleDropdownStyles,
} from "constants/dropdown";
import st from "./simpleDropdown.module.scss";
import { ActionMeta, ValueType } from "react-select/src/types";

/**
 * This SimpleDropdown component wants to live up to its name
 * for being simple. You can pass in values and some style customizations
 * but the selection is optional, there is no validation, and no
 * (error or success) state displays.
 */

export type DropdownOnChangeType = (
  value: ValueType<ReactSelectDropdownOption, false>,
  actionMeta: ActionMeta<ReactSelectDropdownOption>
) => void;

interface SimpleDropdownProps extends FieldProps {
  options: ReactSelectDropdownOption[];
  defaultValue?: ReactSelectDropdownOption;
  styles?: SimpleDropdownStyles;
  placeholder?: string;
  onChange?: DropdownOnChangeType;
}

export const SimpleDropdown: FC<SimpleDropdownProps> = ({
  name,
  options,
  styles,
  ...props
}) => {
  return (
    <Field
      name={name}
      {...props}
      defaultValue={props.defaultValue}
      data-testid="simple-dropdown"
    >
      {({ input }) => (
        <label className={st.label} data-testid="simple-dropdown-label">
          {props.label}
          <Select<ReactSelectDropdownOption>
            {...input}
            name={name}
            components={{
              DropdownIndicator,
            }}
            options={options}
            defaultValue={props.defaultValue}
            styles={simpleDropdownSelectStyles(styles || {})}
            placeholder={props.placeholder}
            isSearchable={false}
            onChange={props.onChange ? props.onChange : input.onChange}
          />
        </label>
      )}
    </Field>
  );
};
